import {
  BaseUXComponent,
  BaseUXComponentActions,
  UXComponentType
} from '../../UXComponentRenderer/uxComponent.types'
import { Label } from '../Label/Label.types'
import { Icon } from '../Icon/Icon.types'

type BaseButtonAttributes = {
  actions: Pick<BaseUXComponentActions, 'onClick' | 'onAdd' | 'onRemove'>
  size: ButtonUXSize
  actionsEnabled?: boolean
}

export enum ButtonUXSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  LargeFullWidth = 'LARGE_FULL_WIDTH'
}

export enum ButtonUXType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY',
  Quaternary = 'QUATERNARY',
  Icon = 'ICON'
}

type TextButtonAttributes = BaseButtonAttributes & {
  type: Exclude<ButtonUXType, ButtonUXType.Icon>
  label: Label
}

export type IconButtonAttributes = BaseButtonAttributes & {
  type: ButtonUXType.Icon
  icon: Icon
}

export type ButtonAttributes = IconButtonAttributes | TextButtonAttributes

export type Button = BaseUXComponent<UXComponentType.Button> & {
  attributes: ButtonAttributes
  className?: string
  onClick?: (e: React.MouseEvent) => void
}
